/*
 *
 * ReportAdmin actions
 *
 */

import {
  GET_LIST_QUESTIONS_WATCHER,
  GET_LIST_QUESTIONS_SUCCESS,
  GET_LIST_QUESTIONS_FAILED,
  GET_LIST_ONLY_QUESTIONS_FAILED,
  GET_LIST_ONLY_QUESTIONS_SUCCESS,
  GET_LIST_ONLY_QUESTIONS_WATCHER,
} from "./constants"

export function getListQuestionsWatcher(payload) {
  return {
    type: GET_LIST_QUESTIONS_WATCHER,
    payload,
  }
}

export function getListQuestionsSuccess(payload) {
  return {
    type: GET_LIST_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getListQuestionsFailed() {
  return { type: GET_LIST_QUESTIONS_FAILED }
}

export function getListOnlyQuestionsWatcher(payload) {
  return {
    type: GET_LIST_ONLY_QUESTIONS_WATCHER,
    payload,
  }
}

export function getListOnlyQuestionsSuccess(payload) {
  return {
    type: GET_LIST_ONLY_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getListOnlyQuestionsFailed() {
  return { type: GET_LIST_ONLY_QUESTIONS_FAILED }
}
